<template>
  <v-app id="offer-with-registration-confirm" :style="{ background: $vuetify.theme.themes.light.background }">
    <v-container class="pt-10 pt-md-15">
      <div class="d-md-flex justify-md-space-between mx-md-n3">
        <div class="text-h6 text-md-h4">
          お申込み
        </div>
        <entry-steps current-step="STEP2"/>
      </div>

      <v-sheet max-width="1024" class="mx-auto">
        <vb-form-section title="お申込み内容">
          <vb-form-row item-name="箱数">
            <template #input>
              {{ getBuyFormItems.numberOfPackages }} 箱
            </template>
          </vb-form-row>
          <vb-form-row item-name="集荷希望日時">
            <template #input>
              {{ formattedPickupDate }}
              {{ getBuyFormLabels.pickupPeriodName }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="クーポンコード">
            <template #input>
              <template v-if="getBuyFormItems.campaignCode">
                <v-sheet>
                  {{ getBuyFormItems.campaignCode }}
                  <p class="text-caption primary--text mb-0">{{ getBuyFormLabels.formattedCampaignName }}が適用されます</p>
                </v-sheet>
              </template>
              <template v-else>
                (なし)
              </template>
            </template>
          </vb-form-row>
          <vb-form-row item-name="支援先">
            <template #input>
              {{ getBuyFormItems.supportGroupName }}
            </template>
          </vb-form-row>
        </vb-form-section>

        <vb-form-section title="集荷先情報">
          <vb-form-row item-name="法人名/団体名">
            <template #input>
              {{ getBuyFormItems.companyName }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="氏名">
            <template #input>
              {{ getBuyFormItems.lastname }}&nbsp;{{ getBuyFormItems.firstname }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="カナ">
            <template #input>
              {{ getBuyFormItems.lastnameKatakana }}&nbsp;{{ getBuyFormItems.firstnameKatakana }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="生年月日">
            <template #input>
              {{
                new Intl.DateTimeFormat('ja-JP', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                }).format(new Date(getBuyFormItems.birthdate))
              }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="郵便番号">
            <template #input>
              {{ getBuyFormItems.postcode }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="集荷先住所">
            <template #input>
              {{ getBuyFormItems.addressPrefecture }}<br/>
              {{ getBuyFormItems.addressLocal1 }}<br/>
              {{ getBuyFormItems.addressLocal2 }}
            </template>
          </vb-form-row>
          <vb-form-row item-name="電話番号">
            <template #input>
              {{ getBuyFormItems.telephoneNumber1 }} - {{ getBuyFormItems.telephoneNumber2 }} -
              {{ getBuyFormItems.telephoneNumber3 }}
            </template>
          </vb-form-row>
        </vb-form-section>

        <vb-form-section title="ご連絡先">
          <vb-form-row item-name="メールアドレス">
            <template #input>
              <v-sheet>
                <p class="text-h5" style="overflow-wrap: anywhere">{{ getMemberFormItems.email }}</p>
                <small class="error--text">
                  「送信」ボタンを押すと、ご本人確認のためのメールが送られます。<br/>
                  メールアドレスが間違っているとお申し込みがやり直しになるため、いま一度ご確認ください。
                </small>
              </v-sheet>
            </template>
          </vb-form-row>
        </vb-form-section>

        <v-row justify="center" class="mt-md-6">
          <v-btn
            class="secondary white--text text-subtitle-1 text-md-h6 mt-16"
            :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
            :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
            @click="gotoCompleted"
            :disabled="this.isTwoClickProtect"
          >
            送信
          </v-btn>
        </v-row>

        <v-row justify="center">
          <v-btn
            class="text-subtitle-1 text-md-h6 my-12"
            :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
            :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
            :to="{
              name: 'CharibonEntryForm',
              params: {isBackButton: true, emailSubscriptionCode: this.getMemberFormItems.emailSubscriptionCode},
              query: $route.query
            }"
          >
            修正する
          </v-btn>
        </v-row>
      </v-sheet>
    </v-container>
    <v-dialog v-model="dialogRetryableError" width="300">
      <v-card>
        <v-card-title class="text-h6 my-4 justify-center">
          エラーが発生しました
        </v-card-title>

        <v-card-text>
          <v-row>エラーを検出したため、実行することができませんでした。</v-row>
          <v-row>しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。</v-row>
        </v-card-text>

        <v-card-actions class="my-4">
          <v-spacer></v-spacer>
          <v-btn @click="dialogRetryableError = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GtmOnVue from "../../../libs/gtmOnVue.js";
import EntrySteps from "../../molecules/buy/entry-steps.vue"
import VbFormSection from "../../organisms/buy/vb-form-section.vue";
import VbFormRow from "../../molecules/buy/vb-form-row.vue";

window.addEventListener('beforeunload', function (event) {
  if (document.getElementById('offer-with-registration-confirm')) {
    // 離脱しようとしていることを、ダイアログで表示する
    event.preventDefault();
    event.returnValue = 'Check';
  }
});

export default {
  name: "charibon-entry-confirm",
  components: {
    VbFormRow,
    VbFormSection,
    EntrySteps,
  },
  data: () => ({
    dialogRetryableError: false,
    isTwoClickProtect: false,
  }),
  beforeRouteEnter(to, from, next) {
    // Back to the form page, if this confirmation page is reloaded.
    if (!from.name) {
      console.info(`from.name is empty on confirm`);

      next({name: "CharibonEntryForm"});
      return;
    }
    next()
  },
  created() {
    GtmOnVue.sendGAEventCharibonOfferAll(
      this.$route.query.id,
      (this.$route.query.kCode ? this.$route.query.kCode : this.$route.query.couponCode),
      this.$route.query.vboffice
    );
  },
  computed: {
    ...mapGetters({
      getMemberFormItems: 'member/getFormItems',
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      formattedPickupDate: 'buy/getFormattedPickupDate',
    }),
  },
  methods: {
    ...mapActions('buy', ['isValidatePickupTime']),
    ...mapActions('member', ['updateFormLabels']),

    async gotoCompleted() {
      this.isTwoClickProtect = true;

      if (!await this.isValidatePickupTime()) {
        this.$router.push({name: "CharibonEntryForm", params: {pickup_date_error: true}});
        return
      }
      const url = '/api/member/create-temporary'
      const response = await axios.post(url, {
        buyParams: this.getBuyFormItems,
        memberParams: this.getMemberFormItems,
      }).catch((e) => {
        this.dialogRetryableError = true;
        if (e.response.status === 422) {
          this.$router.push({name: "CharibonEntryForm", params: {validate_on_load: true}});
        }
      });
      if (response && response.status === 200) {
        this.updateFormLabels({name: 'requestUUID', value: response.data.UUID});

        let dt = new Date(response.data.authenticationExpirationDatetime);
        let date = dt.toLocaleDateString('ja-JP', {
          dateStyle: 'long',
        });
        this.updateFormLabels({
          name: 'authenticationExpirationDatetimeFormatted',
          value: `${date} ${(dt.getHours())}時${(dt.getMinutes())}分`
        });
        this.$router.push({name: "QuickEntryOtp"});
      } else {
        this.dialogRetryableError = true;
      }
      this.isTwoClickProtect = false;
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  .v-application--wrap {
    min-height: unset;
  }
}
</style>